<template>
	<!-- 订单核销 -->
	<div>
		<cube-page type="myorder-view" title="核销">
			<div slot="content">
				<div class="tt-wirte">
					<van-grid clickable :column-num="2">
						<van-grid-item :class="isActive=='0'?'vgiactive':''" icon="scan" text="扫码"
							@click="onOpenQrCode" />
						<van-grid-item :class="isActive=='1'?'vgiactive':''" icon="edit" text="手动输入"
							@click="onOpenWirte" />
					</van-grid>
				</div>
				<div class="wirte-box" v-if="isActive=='1'">
					<van-form @submit="onSubmit">
						<van-field v-model="orderno" name="核销码" placeholder="请输入核销码" clearable
							:rules="[{ required: true, message: '请填写核销码' }]" />
						<div style="margin-top: 30px;">
							<van-button block type="primary" native-type="submit">核销</van-button>
						</div>
					</van-form>
				</div>
				<!-- <p class="hsp">查看核销记录</p> -->
			</div>
		</cube-page>
		<cube-view></cube-view>
		<van-dialog v-model="show" title="订单信息" show-cancel-button confirmButtonText="确认核销" :before-close="beforeClose">
			<div class="hxdialog">
				<div class="ordertitle">
					<p>订单号：{{orderData.order_no}}</p>
				</div>
				<van-card :title="orderData.goods_name" style="margin: 0;">
					<template #desc>
						<div class="footerflex">
							<span></span>
							<span>{{orderData.goods_attr}}</span>
						</div>
						<div class="footerflex">
							<span>使用人：</span>
							<span>{{orderData.contacts}}</span>
						</div>
						<div class="footerflex">
							<span>手机号：</span>
							<span>{{orderData.telephone}}</span>
						</div>
						<div class="footerflex" v-if="orderData.IDCard">
							<span>证件号：</span>
							<span>{{orderData.IDCard}}</span>
						</div>
						<div class="footerflex">
							<span>核销码：</span>
							<span>{{orderData.code}}</span>
						</div>
						<div class="footerflex">
							<span>订单数：</span>
							<span>{{orderData.total_num}}份</span>
						</div>
						<!-- 		<div class="carddesc">
							<span>已核销：</span>
							<span>{{orderData.use_total}}份</span>
						</div>
						<div class="carddesc">
							<span>待核销：</span>
							<span>{{orderData.no_use_total}}份</span>
						</div> -->
					</template>
					<template #footer>
						<div style=" width: 100%; display: flex; flex-direction: column;color: red">
							<div class="footerflex" style="color: #323233">
								<div>使用日期：</div>
								<div>{{orderData.use_time}}</div>
							</div>
							<div class="footerflex">
								<span>已核销：</span>
								<span>{{orderData.use_total}}份</span>
							</div>
							<div class="footerflex">
								<span>已退款：</span>
								<span>{{orderData.refund_total}}份</span>
							</div>
							<div class="footerflex">
								<span>已过期：</span>
								<span>{{orderData.over_total}}份</span>
							</div>
							<div class="footerflex">
								<span>可核销：</span>
								<span>{{orderData.no_use_total}}份</span>
							</div>
							<div class="footerflex" v-show="orderData.no_use_total > 0">
								<span style="color: #333;">本次核销：</span>
								<span>
									<van-stepper v-model="num" theme="round" button-size="22" disable-input
										:max="orderData.no_use_total" />
								</span>
							</div>
						</div>
					</template>
				</van-card>

			</div>
		</van-dialog>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import CubeView from '@/components/TP/cube-view'
	import CubePage from '@/components/TP/cube-page.vue'
	import * as util from '@/utils/network'
	import wx from 'weixin-js-sdk'

	export default {
		components: {
			CubePage,
			CubeView,
		},
		data() {
			return {
				orderData: {},
				show: false,
				wxConfig: [],
				orderno: '',
				isActive: '1', //0 扫一扫   1手动输入
				num: 0
			}
		},
		methods: {
			// 扫一扫
			onOpenQrCode() {
				let that = this
				wx.scanQRCode({
					needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
					scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
					success(res) {
						var code = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
						console.log('扫描结果:', res);
						alert(code);
						that.orderno = code;
						that.onSubmit();
						return false;
					},
					fail(res) {
						alert('微信js-sdk配置失败:::' + JSON.parse(res))
					}
				});
			},
			// 手动输入
			onOpenWirte() {
				this.isActive = '1'
			},
			beforeClose(action, done) {
				let that = this
				if (action === 'confirm') {
					var url = "/addons/litestore/api.supplier/use_wirteoffcode"
					//这里直接调用网络接口
					util.post(url, {
							code: that.orderData.code,
							num: that.num
						},
						function(result) {
							Toast.success(result.msg);
							done();
							that.orderno = ''
							that.orderData = {}
						},
						function fail(err) {
							done();
							that.orderno = ''
							that.orderData = {}
						}
					);
				} else {
					done();
					that.orderno = ''
					that.orderData = {}
					that.num = 0
				}
			},
			onSubmit() {
				
				/****之前的弹出框模式*****/
				let that = this
				var url = "/addons/litestore/api.supplier/get_wirteoffcode"
				//这里直接调用网络接口
				util.post(url, {
						code: that.orderno
					},
					function(result) {
						that.$router.push({
							path: '/wfnew',
							query: {
								code: that.orderno
							}
						})
						// that.orderData = result.data
						// that.num = result.data.no_use_total
						// that.show = true
					},
				);
			},
		}
	}
</script>
<style type="text/css" lang="less">
	@import url("../../assets/css/order.css");

	[class*=van-hairline]::after {
		border: none !important;
	}

	.van-grid-item__content {
		color: #969696;

		.van-icon {
			font-size: 40px;
		}

		.van-grid-item__text {
			color: #969696;
		}
	}

	.vgiactive {

		.van-grid-item__text,
		.van-icon {
			color: #07c160;
			font-weight: 600;
		}
	}
</style>
<style lang="less" scoped="scoped">
	.footerflex {
		display: flex;
		align-items: center;
		width: 100%;
		padding: 5px 0;
		font-size: 14px;
	}

	.hxdialog {
		border-bottom: 1px solid #eeeeee;
		border-top: 1px solid #eeeeee;

		// margin-top: 10px;
		// padding: 0 10px;
		.van-card__title {
			font-size: 15px;
			padding-bottom: 5px;
		}

		.carddesc,
		.van-card__num {
			font-size: 13px;
			padding: 3px 0;
		}
	}

	.tt-wirte {
		padding: 20px;
		background-color: #FFFFFF;
	}

	.wirte-box {
		margin-top: 40px;
		padding: 0 15px;
	}

	.hsp {
		margin-top: 80px;
		font-size: 13px;
		color: #07c160;
		text-align: center;
	}
</style>